import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// EditCategory page components
import FormField from "components/Form/FormField";

function EditForm({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { name, description } = formField;
  const { name: nameV, description: descriptionV } = values;

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">المعلومات الرئيسية </MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
              success={nameV.length > 0 && !errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={description.type}
              label={description.label}
              name={description.name}
              value={descriptionV}
              placeholder={description.placeholder}
              error={errors.description && touched.description}
              success={descriptionV.length > 0 && !errors.description}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

EditForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default EditForm;
